module.exports = __webpack_public_path__ + "img/illus_setup_1.5a630e2c.png";